module.exports = __webpack_public_path__ + "static/summer_hero-ca73f79db60f89175d6ec57275c4b523.png";